<template>
  <div>
    <el-card class="box-card" body-style="min-height:84vh;">
      <div slot="header" class="clearfix">
        <div @click="backPage" class="mt-racede-fff-back flex-row-align">
          <i class="el-icon-arrow-left"></i>返回
        </div>
      </div>
      <div>
        <el-form :model="editForm" :rules="rules" ref="editForm" label-width="190px" size="small" class="demo-ruleForm">
          <el-form-item label="奖品类型：" prop="prizeType">
            <el-radio-group v-model="editForm.prizeType">
                <el-radio :label="1">优惠券</el-radio>
                <el-radio :label="2">积分</el-radio>
                <el-radio :label="3">商品</el-radio>
                <el-radio :label="4">未中奖</el-radio>
              </el-radio-group>
          </el-form-item>
          <el-form-item v-if="editForm.prizeType == 1 || editForm.prizeType == 3" :label="editForm.prizeType == 1 ? '选择优惠券：' : '选择商品：'" prop="businessId">
            <el-button @click="goodsOpenBtn">添加{{editForm.prizeType == 1 ? '优惠券' : '商品'}}</el-button>
            <el-table
              v-if="multipleSelectionSure.length > 0 && editForm.prizeType == 3"
              style="margin-top: 16px;width: 476px;"
              border
              :data="multipleSelectionSure">
              <el-table-column
                align="center"
                prop="goodsName"
                label="商品名称">
              </el-table-column>
              <el-table-column
                align="center"
                prop="goodsSpecName"
                label="规格">
              </el-table-column>
              <el-table-column
                align="center"
                prop="goodsSpecPrice"
                label="商品价格">
              </el-table-column>
            </el-table>
            <el-table
              v-if="multipleCouponSelectionSure.length > 0 && editForm.prizeType == 1"
              style="margin-top: 16px;width: 476px;"
              border
              :data="multipleCouponSelectionSure">
              <el-table-column
                align="center"
                prop="couponName"
                label="优惠券名称">
              </el-table-column>
              <el-table-column
                align="center"
                prop="couponType"
                label="优惠券类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.couponType === 1">商城通用券</span>
                  <span v-else-if="scope.row.couponType === 2">商城满减券</span>
                  <span v-else-if="scope.row.couponType === 3">商城品类通用券</span>
                  <span v-else-if="scope.row.couponType === 4">商城品类满减券</span>
                  <span v-else-if="scope.row.couponType === 5">商城商品券</span>
                  <span v-else-if="scope.row.couponType === 6">门店通用券</span>
                  <span v-else-if="scope.row.couponType === 7">门店满减券</span>
                  <span v-else-if="scope.row.couponType === 8">单门店通用券</span>
                  <span v-else-if="scope.row.couponType === 9">单门店满减券</span>
                  <span v-else-if="scope.row.couponType === 10">门店单品券</span>
                  <span v-else-if="scope.row.couponType === 11">多门店通用券</span>
                  <span v-else-if="scope.row.couponType === 12">多门店满减券</span>
                  <span v-else-if="scope.row.couponType === 13">全局通用券</span>
                  <span v-else-if="scope.row.couponType === 14">全局满减券</span>
                </template>
              </el-table-column>
              <el-table-column
                align="center"
                prop="couponMoney"
                label="优惠券金额">
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item v-if="editForm.prizeType == 2" label="积分数量：" prop="businessId">
            <el-input style="width: 424px;" v-model="editForm.businessId" placeholder="请输入积分数量"></el-input>
          </el-form-item>
          <el-form-item label="显示名称：" prop="displayName">
            <el-input style="width: 424px;" v-model="editForm.displayName" placeholder="请输入显示名称"></el-input>
          </el-form-item>
          <el-form-item v-if="editForm.prizeType == 1 || editForm.prizeType == 2 || editForm.prizeType == 3" label="投放数量：" prop="totalQuantity">
            <el-input style="width: 424px;" v-model="editForm.totalQuantity" placeholder="请输入投放数量"></el-input>
          </el-form-item>
          <el-form-item label="抽中概率：" prop="winProbability">
            <el-input @input="writeInput" style="width: 424px;" v-model="editForm.winProbability" placeholder="请输入抽中概率"></el-input>
            <div class="mt-warm-txt"><span>概率（%），共100%，已输入 <span :style="totalWinProbability > 100 ? 'color:red' : 'color:#999'">{{totalWinProbability}}%</span></span></div>
          </el-form-item>
          <el-form-item label="图片：" prop="imageUrl">
            <el-upload
              :action="baseUrl+'/system/common/upload/uploadFile'"
              list-type="picture-card"
              :headers="{'Authorization': token}"
              :multiple="false"
              :limit="1"
              :file-list="imageUrlList"
              :on-remove="delImgBtn.bind(null,{'type':1})"
              :on-success="uploadImgBtn.bind(null,{'type':1})">
              <i class="el-icon-plus"></i>
              <div slot="tip" class="el-upload__tip">建议尺寸：96*96px，最多一张，若需要更换图片，请先删除原图片</div>
            </el-upload>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="medium" @click="saveBtn">保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <!-- 选择商品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsShow"
      width="960px">
      <el-form :model="searchForm" inline ref="searchForm" label-width="100px" class="demo-ruleForm">
        <el-form-item :label="editForm.prizeType == 1 ? '优惠券名称：' : '商品名称：'" prop="name">
          <el-input class="mt-search-width" v-model="searchForm.name" :placeholder="editForm.prizeType == 1 ? '请输入优惠券名称' : '请输入商品名称'"></el-input>
          <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <el-table
        ref="multipleTable"
        border
        highlight-current-row
        :data="infoList"
        @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
          <template slot-scope="scope">
            <el-radio
                class="radio"
                :label="scope.row"
                v-model="multipleSelection"
              >{{""}}</el-radio>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :prop="editForm.prizeType == 1 ? 'id' : 'goodsSpecId'"
          label="ID">
        </el-table-column>
        <el-table-column
          v-if="editForm.prizeType == 3"
          align="center"
          prop="goodsSpecThumb"
          label="商品图">
          <template slot-scope="scope">
            <el-image
              style="width: 40px;"
              :src="scope.row.goodsSpecThumb"
              :preview-src-list="[scope.row.goodsSpecThumb]"
              fit="contain"></el-image>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :prop="editForm.prizeType == 1 ? 'couponName' : 'goodsName'"
          :label="editForm.prizeType == 1 ? '优惠券名称' : '商品名称'">
        </el-table-column>
        <el-table-column
          v-if="editForm.prizeType == 3"
          align="center"
          prop="goodsSpecName"
          label="商品规格">
        </el-table-column>
        <el-table-column
          v-if="editForm.prizeType == 1"
          align="center"
          prop="couponType"
          label="优惠券类型">
          <template slot-scope="scope">
            <span v-if="scope.row.couponType === 1">商城通用券</span>
            <span v-else-if="scope.row.couponType === 2">商城满减券</span>
            <span v-else-if="scope.row.couponType === 3">商城品类通用券</span>
            <span v-else-if="scope.row.couponType === 4">商城品类满减券</span>
            <span v-else-if="scope.row.couponType === 5">商城商品券</span>
            <span v-else-if="scope.row.couponType === 6">门店通用券</span>
            <span v-else-if="scope.row.couponType === 7">门店满减券</span>
            <span v-else-if="scope.row.couponType === 8">单门店通用券</span>
            <span v-else-if="scope.row.couponType === 9">单门店满减券</span>
            <span v-else-if="scope.row.couponType === 10">门店单品券</span>
            <span v-else-if="scope.row.couponType === 11">多门店通用券</span>
            <span v-else-if="scope.row.couponType === 12">多门店满减券</span>
            <span v-else-if="scope.row.couponType === 13">全局通用券</span>
            <span v-else-if="scope.row.couponType === 14">全局满减券</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          :prop="editForm.prizeType == 1 ? 'couponMoney' : 'goodsSpecPrice'"
          :label="editForm.prizeType == 1 ? '优惠券金额' : '商品价格'">
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
      <div class="flex-end-row" style="margin-top:24px;">
        <el-button type="primary" @click="goodsSureBtn">确认选择</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { saveLotteryActivityPrize, fetchLotteryActivityPrizeDetailById, updateLotteryActivityPrize, queryEnableGoodsSpecPageList, queryEnableCouponPageList, getLotteryPrizeTotalWinProbability } from '@/api/prizeDraw'
export default {
  name: 'PrizeDrawManageAdd',
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      token:this.$token,
      fullscreenLoading: false,
      dataId: this.$route.query.dataId,
      activityConfigId: this.$route.query.activityConfigId,
      imageUrlList: [],
      businessIdArr:[],
      totalWinProbability:'',
      oldTotalWinProbability:'',
      oldWinProbability:0,
      editForm: {
        prizeType:1,
        businessId:'',
        displayName:'',
        totalQuantity:'',
        winProbability: '',
        imageUrl:''
      },
      rules: {
        prizeType: [
          { required: true, message: '请选择奖品类型', trigger: 'blur' }
        ],
        businessId: [
          { required: true, message: '请选择', trigger: 'blur' }
        ],
        displayName: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        totalQuantity: [
          { required: true, message: '请输入投放数量', trigger: 'blur' }
        ],
        winProbability: [
          { required: true, message: '请输入中奖概率', trigger: 'blur' }
        ],
        imageUrl: [
          { required: true, message: '请上传图片', trigger: 'blur' }
        ]
      },
      // 选择商品弹窗
      searchForm: {
        name:''
      },
      goodsShow:false,
      multipleSelection: [],
      multipleSelectionSure: [],
      multipleCouponSelectionSure: [],
      pageTotal: 0,
      currentPage: 1,
      limitLength: this.$limitLength,
      infoList:[]
    }
  },
  mounted () {
    let token = sessionStorage.getItem('token')
    if (!token) {
      token = ''
    }
    this.token = token;
    if(this.dataId != ''){
      // 编辑信息
      this.detailInfoFun();
    }else{
          that.hasTotalWinProbabilityFun();
    }
  },
  methods: {
    /* 商品详情数据 */
    detailInfoFun(){
      var that = this;
      fetchLotteryActivityPrizeDetailById({id:that.dataId}).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data;
          // 图片
          that.imageUrlList.push({url: data.imageUrl});
          that.editForm = data;
          that.oldWinProbability = data.winProbability;
          that.hasTotalWinProbabilityFun();
        }
        if (res.errorCode === '1001') {
          that.$message.error(res.msg);
        }
      });
    },
    // 已输入抽奖概率
    hasTotalWinProbabilityFun(){
      var that = this;
      getLotteryPrizeTotalWinProbability({id:that.dataId}).then((resp) => {
        if (resp.errorCode === '0000') {
          let datar = resp.data;
          that.totalWinProbability = datar;
          that.oldTotalWinProbability = datar;
        }
      });
    },
    writeInput(e){
      let that = this;
      let totalWinProbability = parseFloat(that.oldTotalWinProbability)-parseFloat(that.oldWinProbability)+parseFloat(that.editForm.winProbability)
      that.totalWinProbability = totalWinProbability.toFixed(2);
    },
    // 商品主图上传
    uploadImgBtn (obj, file) {
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 背景图
          that.editForm.imageUrl = file.data.fileUrl
          break;
      }
    },
    /* 删除上传的图片 */
    delImgBtn(obj,file,fileList){
      var type = obj.type;
      var that = this;
      switch (type) {
        case 1:
          // 背景图
          var thumb = '';
          fileList.forEach(function(item){
            thumb = item.url;
          });
          that.editForm.imageUrl = thumb;
          break;
      }
    },
    // 保存操作
    saveBtn(){
      var that = this;
      var activityConfigId = that.activityConfigId;
      var dataId = that.dataId;
      var editForm = that.editForm;
      if(editForm.prizeType == 1){
        // 优惠券
        editForm.businessId = that.multipleCouponSelectionSure[0].id;
      }
      if(editForm.prizeType == 3){
        // 商品
        editForm.businessId = that.multipleSelectionSure[0].goodsSpecId;
      }
      let passData = {
        activityConfigId:activityConfigId,
        prizeType: editForm.prizeType,
        businessId:editForm.businessId,
        displayName:editForm.displayName,
        totalQuantity:editForm.totalQuantity,
        winProbability:editForm.winProbability,
        imageUrl:editForm.imageUrl
      }
      if(dataId != ''){
        passData.id = dataId;
        updateLotteryActivityPrize(passData).then((res) => {
          that.backDataFun(res);
        })
      }else{
        saveLotteryActivityPrize(passData).then((res) => {
          that.backDataFun(res);
        })
      }
    },
    backDataFun(res){
      var that = this
      if (res.errorCode === '0000') {
        this.$message({
          message: res.msg,
          type: 'success',
          onClose () {
            that.$router.go(-1)
          }
        })
      }
      if (res.errorCode === '1001') {
        this.$message.error(res.msg)
      }
    },
    // 返回上一页
    backPage () {
      this.$router.go(-1)
    },
    // 选择商品弹窗-打开弹窗
    goodsOpenBtn(){
      this.getInfoList();
      this.goodsShow = true;
    },
    /* 选择商品弹窗-搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 选择商品弹窗-选择商品操作
    handleSelectionChange(val) {
      // 单选
      if (val.length > 1 ) {
          this.$refs.multipleTable.clearSelection();
          this.$refs.multipleTable.toggleRowSelection(val.pop());
      }
      this.multipleSelection = val;
    },
    // 选择商品弹窗-确认选择
    goodsSureBtn(){
      var multipleSelection = [this.multipleSelection];
      if(multipleSelection.length == 0){
        this.$message.error('请先选择');
        return false;
      }
      if(this.editForm.prizeType == 1){
        // 优惠券
        this.multipleCouponSelectionSure = multipleSelection;
      }else if(this.editForm.prizeType == 3){
        // 商品
        this.multipleSelectionSure = multipleSelection;
      }
      this.goodsShow = false;
    },
    // 选择商品弹窗-获取数据
    getInfoList () {
      let that = this
      let searchName = that.searchForm.name
      let page = that.currentPage
      if(that.editForm.prizeType == 1){
        // 优惠券
        queryEnableCouponPageList({ webSearchStr: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            data.forEach(function(item){
              item.status = item.status == 1 ? true : false;
            });
            that.infoList = data
            that.pageTotal = res.total
          }
          if (res.errorCode === '4002') {
            that.infoList = []
            that.pageTotal = res.total
          }
        })
      }else if(that.editForm.prizeType == 3){
        // 商品
        queryEnableGoodsSpecPageList({ webSearchStr: searchName, pageNum: page, pageSize: that.limitLength}).then((res) => {
          if (res.errorCode === '0000') {
            let data = res.data
            data.forEach(function(item){
              item.status = item.status == 1 ? true : false;
            });
            that.infoList = data
            that.pageTotal = res.total
          }
          if (res.errorCode === '4002') {
            that.infoList = []
            that.pageTotal = res.total
          }
        })
      }
    },
    // 选择商品弹窗-当前页码操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/market/prizeDraw/PrizeDrawManageAdd.vue